import { abasAntigasOff, ABAS_ANTIGAS_PATHS } from '../../lib/abasAntigas0311'; // ABAS_ANTIGAS_WHATS_0311
import {
  AppWindow, Home, MessageCircle, Users, DollarSign, Settings as SettingsIcon,
  Phone, UsersRound, Cable, ShieldCheck, LayoutDashboard, Tv, Briefcase,
  Settings2, Gift, Layers, ScrollText, ClipboardList, Trophy, Wallet, BellRing,
  Library, Package, SlidersHorizontal, Radio, Video, Link2, Smartphone, Megaphone,
} from 'lucide-react';
import { WhatsAppIcon } from '../ServiceBrandIcon';

/**
 * Catálogo base do Office. completeOfficeNavigation acrescenta os destinos
 * avançados autorizados ao menu completo, sem um segundo hub no cabeçalho.
 *
 * Créditos: revendas operam exclusivamente no Modo crédito.
 */
export const OFFICE_MODULES = [
  {
    id: 'home',
    label: 'Início',
    icon: LayoutDashboard,
    defaultPath: '/dashboard',
    items: [
      { path: '/dashboard', label: 'Painel', icon: Home, permKey: 'dashboard' },
      { path: '/extras', label: 'Extras', icon: Gift }, // EXTRAS_2910
      { path: '/comunicados', label: 'Comunicados', icon: Megaphone, hideForAttendant: true, permKey: 'comunicados' }, // PERM_ABAS_EXTRA_2810
    ],
  },
  {
    id: 'crm',
    label: 'Atendimento',
    icon: Briefcase,
    defaultPath: '/chats',
    items: [
      { path: '/chats', label: 'Atendimentos', icon: MessageCircle, permKey: 'chats', badgeKey: 'totalUnread' },
      // AURAX_REDESIGN_2710 (GROK2): espelho de atendimento (switch ATENDIMENTO_ESPELHO_OFF -> redireciona p/ /chats)
      { path: '/atendimento', label: 'Atendimento', icon: MessageCircle, permKey: 'chats', hideForAttendant: true },
      { path: '/reunioes', label: 'Reuniões', icon: Video, permKey: 'meetings' },
      {
        path: '/notification-templates',
        label: 'Notificações',
        icon: BellRing,
        permKey: 'notification_templates',
      },
      {
        path: '/materiais',
        label: 'Materiais',
        icon: Library,
        permKey: 'reseller_manual',
        hideForAdmin: true,
        badgeKey: 'manualUnread',
      },
    ],
  },
  {
    id: 'creditos',
    label: 'Financeiro e créditos',
    icon: Wallet,
    defaultPath: '/buy-credits',
    items: [
      // AURAX_REDESIGN_2710 (GROK2): aba Financeiro (switch FINANCEIRO_ABA_OFF -> redireciona p/ /sales)
      { path: '/financeiro', label: 'Financeiro', icon: DollarSign, permKey: 'financeiro', hideForAttendant: true },
      { path: '/sales', label: 'Visão financeira', icon: DollarSign, permKey: 'financeiro' },
      { path: '/logs-financeiros', label: 'Movimentações', icon: ScrollText, permKey: 'financeiro' },
      { path: '/logs-globais', label: 'Auditoria global', icon: ClipboardList, permKey: 'logs_globais', adminOnly: true },
      { path: '/ranking', label: 'Ranking comercial', icon: Trophy, hideForAttendant: true },
      {
        path: '/buy-credits',
        label: 'Comprar créditos',
        icon: Wallet,
        permKey: 'buy_credits',
        billingMode: 'prepaid',
        hideForAdmin: true,
      },
      {
        path: '/gestor-xui/credit-packs',
        label: 'Pacotes de crédito',
        icon: Package,
        permKey: 'credit_packs',
        billingMode: 'prepaid',
      },
      {
        path: '/gestor-xui/reseller-billing',
        label: 'Modo crédito',
        icon: SlidersHorizontal,
        permKey: 'credit_packs',
        adminOnly: true,
      },
    ],
  },
  {
    id: 'gestao',
    label: 'Clientes e rede',
    icon: UsersRound,
    defaultPath: '/gestor-xui/clients',
    items: [
      { path: '/gestor-xui/tests', label: 'Testes', icon: Gift, permKey: 'clients' },
      { path: '/gestor-xui/vencimentos', label: 'Vencimentos', icon: Gift, permKey: 'clients' }, // VENCIMENTOS_2910
      { path: '/gestor-xui/passo-a-passo', label: 'Passo a passo', icon: Gift, permKey: 'clients' }, // PASSO_A_PASSO_2910
      { path: '/gestor-xui/clients', label: 'Clientes', icon: Users, permKey: 'clients' },
      { path: '/bonification', label: 'Página de Bonificação', icon: Gift, permKey: 'bonification', hideForAttendant: true },
      { path: '/gestor-xui/live-clients', label: 'Clientes conectados', icon: Radio, permKey: 'clients' },
      { path: '/gestor-xui/resellers', label: 'Revendas', icon: UsersRound, permKey: 'resellers' },
      {
        path: '/gestor-xui/my-portfolio',
        label: 'A minha carteira',
        icon: Link2,
        permKey: 'resellers',
        hideForAdmin: true,
      },
      {
        path: '/gestor-xui/my-reseller-billing',
        label: 'Modo crédito da rede',
        icon: SlidersHorizontal,
        permKey: 'reseller_billing',
        hideForAdmin: true,
        billingMode: 'prepaid',
      },
    ],
  },
  {
    id: 'applications', label: 'Aplicativos', icon: Smartphone, defaultPath: '/app-activations',
    items: [
      { path: '/app-activations', label: 'Ativar aplicativos', icon: Smartphone, permKey: 'clients', attendantPerm: 'app_activations_manage' },
      { path: '/gestor-xui/own-player', label: 'Aplicativo próprio', icon: AppWindow, permKey: 'clients', hideForAttendant: true, ownPlayerOnly: true },
      { path: '/gestor-xui/partner-apps', label: 'Catálogo de aplicativos', icon: Library, permKey: 'clients' },
    ],
  },
  {
    id: 'iptv',
    label: 'Conteúdo',
    icon: Tv,
    defaultPath: '/gestor-xui/categories',
    items: [
      { path: '/gestor-xui/categories', label: 'Planos', icon: Layers, permAny: ['clients', 'plan_pricing'] },
      { path: '/gestor-xui/catalog', label: 'Conteúdos', icon: Tv, permAny: ['clients', 'plan_pricing'] },
    ],
  },
  {
    id: 'admin',
    label: 'Equipe e canais',
    icon: ShieldCheck,
    defaultPath: '/connections',
    items: [
      { path: '/connections', label: 'WhatsApp', icon: WhatsAppIcon, permKey: 'whatsapp' },
      { path: '/team', label: 'Equipe', icon: UsersRound, permKey: 'team' },
    ],
  },
  {
    id: 'config',
    label: 'Configurações',
    icon: Settings2,
    defaultPath: '/settings',
    items: [
      { path: '/settings', label: 'Ajustes', icon: SettingsIcon, permAny: ['settings', 'settings_password_only'] },
      {
        path: '/community-support',
        label: 'Comunidade & suporte',
        icon: MessageCircle,
        adminOnly: true,
        permKey: 'settings',
      },
      { path: '/gestor-xui/servers', label: 'Servidores', icon: Cable, adminOnly: true, permKey: 'integrations' },
      { path: '/api-integrations', label: 'API e automações', icon: Cable, hideForAttendant: true, permKey: 'api_integrations' }, // PERM_ABAS_EXTRA_2810
      { path: '/permissions', label: 'Permissões', icon: ShieldCheck, adminOnly: true, permKey: 'permissions' },
    ],
  },
];

/** Destinos complementares do menu e da busca; preservam a política office_tools_paths da API. */
export const OFFICE_TOOL_LINKS = [
  { path: '/contacts', label: 'Contatos (CRM)', hint: 'Contatos e estágios', permKey: 'contacts' },
  { path: '/funnel', label: 'Funil de vendas', hint: 'Quadro de contatos', permKey: 'funnel' },
  { path: '/gestor-xui/credential-generation', label: 'Credenciais', hint: 'Padrão de usuário e senha', permKey: 'credential_generation', adminOnly: true },
  { path: '/gestor-xui/reseller-billing', label: 'Modo crédito', hint: 'Validade e regras de créditos', permKey: 'credit_packs', adminOnly: true },
  { path: '/gestor-xui/gateway', label: 'Integrações com bancos', hint: 'Configure pagamentos, recebimentos e cobranças PIX.', permKey: 'gateway' },
  { path: '/gestor-xui/credit-packs', label: 'Pacotes de crédito', hint: 'Tabelas de venda', permKey: 'credit_packs', billingMode: 'prepaid' },
  { path: '/gestor-xui/credit-logs', label: 'Extrato de créditos', hint: 'Movimentos da carteira IPTV', permKey: 'sales_monitor' },
  {
    path: '/gestor-xui/my-reseller-billing',
    label: 'Modo crédito da rede',
    hint: 'Créditos das sub-revendas',
    permKey: 'reseller_billing',
    billingMode: 'prepaid',
  },
  { path: '/aurax-ai', label: 'Agente IA', hint: 'Históricos, conhecimento e atendimento com revisão da equipe.', permKey: 'triggers', hideForAttendant: true },
  { path: '/triggers/chatbot', label: 'Chatbot', hint: 'Scripts, menus e respostas automáticas.', permKey: 'triggers', hideForAttendant: true },
  { path: '/triggers', label: 'Gatilhos', hint: 'Respostas rápidas e automações de mensagens.', permKey: 'triggers' },
  {
    path: '/recuperacao',
    label: 'Sistema de Recuperação',
    hint: 'Campanhas WhatsApp com IA',
    permKey: 'mass_dispatch',
  },
  { path: '/gestor-xui/inactive-clients', label: 'Clientes inativos', hint: 'Limpeza de base', permKey: 'clients', adminOnly: true },
  { path: '/gestor-xui/inactive-resellers', label: 'Revendas inativas', hint: 'Limpeza de árvore', permKey: 'resellers', adminOnly: true },
  { path: '/gestor-xui/reseller-migration', label: 'Migração por M3U', hint: 'Importe clientes por URL M3U ou Xtream', permKey: 'resellers', adminOnly: true },
  {
    path: '/admin/materiais',
    label: 'Materiais para revenda',
    hint: 'Biblioteca e envios',
    permKey: 'reseller_manual_admin',
    adminOnly: true,
  },
];

export function sidebarItemPaths(modules = OFFICE_MODULES) {
  return new Set(
    (modules || []).flatMap((mod) => (mod.items || []).map((item) => item.path).filter(Boolean)),
  );
}

/** Visibilidade compartilhada pelos destinos base e complementares. */
export function navItemVisible(item, { isAdmin, isAttendant, can, billing, ownPlayerAccess = false }) {
  if (!item) return false;
  if (item.ownPlayerOnly && !ownPlayerAccess) return false;
  if (item.adminOnly && !isAdmin) return false;
  if (item.attendantOnly && !isAttendant) return false;
  if (item.hideForAttendant && isAttendant) return false;
  if (item.hideForAdmin && isAdmin) return false;
  if (item.attendantPerm && isAttendant) return can(item.attendantPerm);
  const keys =
    Array.isArray(item.permAny) && item.permAny.length
      ? item.permAny
      : item.permKey
        ? [item.permKey]
        : [];
  if (!keys.length) return true;
  return keys.some((key) => can(key));
}

export function visibleToolLinks({ isAdmin, isAttendant, can, billing, hubPaths, aiStudioAccess = false }) {
  const inSidebar = sidebarItemPaths();
  const hubSet =
    !isAdmin && Array.isArray(hubPaths) ? new Set(hubPaths.map(String)) : null;
  return OFFICE_TOOL_LINKS.filter((tool) => {
    if (tool.path === '/aurax-ai' && aiStudioAccess !== true) return false;
    if (abasAntigasOff() && ABAS_ANTIGAS_PATHS.includes(tool.path)) return false; // ABAS_ANTIGAS_WHATS_0311
    if (inSidebar.has(tool.path)) return false;
    if (hubSet && !hubSet.has(tool.path) && !(tool.path === '/triggers/chatbot' && hubSet.has('/triggers'))) return false;
    return navItemVisible(tool, { isAdmin, isAttendant, can, billing });
  });
}

export const PAGE_TITLES = {
  '/api-integrations': 'API e automações',
  '/dashboard': (typeof window !== 'undefined' && (() => { try { return JSON.parse(window.localStorage.getItem('aurax_flags_v1') || '{}').menu_ordem; } catch (_) { return false; } })()) ? 'Dashboard' : 'Painel', // MENU_ORDEM_2810
  '/comunicados': 'Comunicados',
  '/attendant/metrics': 'Minhas métricas',
  '/chats': 'Atendimentos',
  '/atendimento': (typeof window !== 'undefined' && (()=>{ try { return !!JSON.parse(window.localStorage.getItem('aurax_flags_v1') || '{}').menu_ordem; } catch (_) { return false; } })()) ? 'DataCrazy Chat' : 'Atendimento', // MENU_ORDEM_2810
  '/financeiro': 'Financeiro',
  '/reunioes': 'Reuniões',
  '/contacts': 'Contatos',
  '/funnel': 'Funil de vendas',
  '/triggers': 'Gatilhos',
  '/triggers/chatbot': 'Chatbot',
  '/sales': 'Financeiro',
  '/logs-financeiros': 'Registros financeiros',
  '/logs-globais': 'Registros globais',
  '/ranking': 'Ranking',
  '/buy-credits': 'Comprar créditos',
  '/postpaid-wallet': 'Comprar créditos',
  '/gestor-xui/credit-packs': 'Pacotes de crédito',
  '/gestor-xui/reseller-billing': 'Modo crédito',
  '/gestor-xui/clients': 'Clientes',
  '/gestor-xui/live-clients': 'Clientes conectados',
  '/gestor-xui/tests': 'Testes',
  '/gestor-xui/vencimentos': 'Vencimentos',
  '/gestor-xui/passo-a-passo': 'Passo a passo',
  '/gestor-xui/categories': 'Planos',
  '/gestor-xui/catalog': 'Conteúdos',
  '/gestor-xui/partner-apps': 'Catálogo de aplicativos',
  '/gestor-xui/own-player': 'Aplicativo próprio',
  '/app-activations': 'Ativar aplicativos',
  '/gestor-xui/resellers': 'Revendas',
  '/gestor-xui/my-portfolio': 'A minha carteira',
  '/gestor-xui/plan-pricing': 'Planos',
  '/gestor-xui/servers': 'Servidores',
  '/gestor-xui/credit-logs': 'Extrato de créditos',
  '/gestor-xui/gateway': 'Integrações com bancos',
  '/gestor-xui/credential-generation': 'Credenciais',
  '/gestor-xui/my-reseller-billing': 'Modo crédito da rede',
  '/connections': 'WhatsApp',
  '/settings': 'Ajustes',
  '/community-support': 'Comunidade & suporte',
  '/permissions': 'Permissões',
  '/team': 'Equipe',
  '/team/monitor': 'Equipe',
  '/notification-templates': 'Notificações',
  '/materiais': 'Materiais',
  '/admin/materiais': 'Materiais para revenda',
  '/recuperacao': 'Sistema de Recuperação',
  '/mass-dispatch': 'Sistema de Recuperação',
};

export function titleForPath(pathname) {
  const path = String(pathname || '')
    .split('?')[0]
    .replace(/\/+$/, '') || '/';
  if (PAGE_TITLES[path]) return PAGE_TITLES[path];
  let best = '';
  let bestTitle = '';
  for (const [p, title] of Object.entries(PAGE_TITLES)) {
    if (path === p || path.startsWith(`${p}/`)) {
      if (p.length >= best.length) {
        best = p;
        bestTitle = title;
      }
    }
  }
  if (bestTitle) return bestTitle;
  for (const mod of OFFICE_MODULES) {
    const hit = mod.items.find((i) => i.path === path || path.startsWith(`${i.path}/`));
    if (hit) return hit.label;
  }
  const tool = OFFICE_TOOL_LINKS.find((t) => t.path === path || path.startsWith(`${t.path}/`));
  if (tool) return tool.label;
  return 'Escritório';
}
